import React from "react";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { ConfigurationStore } from "stores";

const Router: React.FC = ({ children }): JSX.Element | null => {
  const configuration = React.useContext(ConfigurationStore);
  if (!configuration) return null;
  if (
    !configuration.basename &&
    configuration.application?.router &&
    configuration.application.router === "hash"
  ) {
    return <HashRouter>{children}</HashRouter>;
  }

  return (
    <BrowserRouter
      basename={configuration.basename || configuration.router?.basename || ""}
    >
      {children}
    </BrowserRouter>
  );
};

export default Router;
